import { render, staticRenderFns } from "./CommunityDashboard.vue?vue&type=template&id=731669e4"
import script from "./CommunityDashboard.vue?vue&type=script&lang=js"
export * from "./CommunityDashboard.vue?vue&type=script&lang=js"
import style0 from "./CommunityDashboard.vue?vue&type=style&index=0&id=731669e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports